import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

/**
 * On or off, with the state carried by more than colour.
 *
 * The thumb's POSITION is the primary marker and survives forced-colours mode
 * and a colour-blind reader; the fill is emphasis on top of it. `forced-outline`
 * puts a system-coloured edge back when Windows high contrast replaces the
 * palette wholesale.
 */
export function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'peer inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent',
        'transition-colors duration-[var(--motion-duration-fast)] ease-standard',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-page',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted',
        'forced-outline',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'pointer-events-none block size-6 rounded-full bg-raised shadow-sm ring-0',
          'transition-transform duration-[var(--motion-duration-fast)] ease-standard',
          'data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
